import React from 'react';
import PropTypes from 'prop-types';
import FeatureCard from './Card';

const SectionFeaturesGrid = ({ header, items }) => {
  return (
    <div className="bg-[#F8F9FB] text-center lg:text-left px-8 py-14 md:px-24 xl:px-36 2xl:px-60 lg:py-12 w-full">
      <h2 className="text-4xl font-bold text-center mb-10">{header}</h2>
      <div className="flex flex-col gap-11 lg:flex-row justify-between items-center max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {items.map((item, index) => (
            <FeatureCard key={index} imageSrc={item.image.url} title={item.header} description={item.body} />
          ))}
        </div>
      </div>
    </div>
  );
};

SectionFeaturesGrid.propTypes = {
  header: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.shape({
        url: PropTypes.string.isRequired
      }).isRequired,
      header: PropTypes.string,
      headerClasses: PropTypes.string,
      body: PropTypes.string,
    })
  ),
};

export default SectionFeaturesGrid;
